import { FlexColumn, StyledBanner, StyledButton } from '@gorila-shared-ui/components';
import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useAuth } from '../../hooks/useAuth';
import { authErrorState } from '../../storage/app';
import { LoginContainer } from '../login/LoginContainer';
import { LoginForm } from '../login/LoginForm';
import { HeadTitle } from '../shared/HeadTitle';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useRecoilState(authErrorState);
  const [retryLogin, setRetryLogin] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async () => {
    if (error && !retryLogin) {
      setRetryLogin(true);
      setError('');
      return;
    }
    setLoading(true);
    const response = await login(username, password);
    if (response?.error) {
      setError(`${response.error}`);
    } else {
      navigate('/', { replace: true });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (retryLogin) {
      setRetryLogin(false);
      handleLogin();
    }
  }, [retryLogin]);

  useEffect(() => {
    const validateSession = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) navigate('/');
      } catch (err) {}
    };
    validateSession();
  });

  return (
    <LoginContainer>
      <HeadTitle title="Iniciar sesión" />
      <FlexColumn centered>
        <LoginForm
          user={username}
          password={password}
          onChangeUser={setUsername}
          onChangePass={setPassword}
          onSubmit={handleLogin}
        />
        {error && (
          <StyledBanner
            title="*Error*"
            kind="negative"
            full
            action={{
              label: 'Label',
              onClick: () => {
                setError('');
              },
            }}
          >
            {error}
          </StyledBanner>
        )}
        <StyledButton full size="default" onClick={handleLogin} isLoading={loading}>
          Ingresar
        </StyledButton>
      </FlexColumn>
    </LoginContainer>
  );
}
